export default "__VITE_ASSET__C8dkMnxG__"